module.exports = __webpack_public_path__ + "static/media/forward.604de8af.svg";